// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__EU_VH","layoutSidebar":"styles_layoutSidebar__c2jxX"};